import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CartSharedModule, AddedToCartDialogEventListener } from "@spartacus/cart/base/components";
import { UrlModule, I18nModule, provideDefaultConfig } from "@spartacus/core";
import { SpinnerModule, PromotionsModule, IconModule, ItemCounterModule, KeyboardFocusModule, MediaModule } from "@spartacus/storefront";
import { CustomLayoutConfig } from "src/app/layout/layout-config";
import { AddToCartDialogComponent } from "./added-to-cartdialog.component";

@NgModule({
    imports: [
      CommonModule,
      ReactiveFormsModule,
      CartSharedModule,
      RouterModule,
      SpinnerModule,
      PromotionsModule,
      UrlModule,
      IconModule,
      I18nModule,
      ItemCounterModule,
      KeyboardFocusModule,
      MediaModule,
    ],
    providers: [provideDefaultConfig(CustomLayoutConfig)],
    declarations: [AddToCartDialogComponent],
    exports: [AddToCartDialogComponent],
  })
  export class AddedToCartDialogModule {
    constructor(_addToCartDialogEventListener: AddedToCartDialogEventListener) {
      // Intentional empty constructor
    }
  }
  